import { Caption, Flex, useAppDisplayModeContext } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import FilterBarForBoards from '~/modules/design-board/component/board-list/FilterBarForBoards';
import { BoardListFilterNav } from '~/modules/design-board/component/mobile-filter-nav/BoardListFilterNav';
import * as S from './BoardListFilter.style';

const BoardListFilter = () => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();

    return mobile ? (
        <BoardListFilterNav itemButtons={[]} />
    ) : (
        <Flex className={css(S.BaseStyle)} column={false}>
            <Caption className={css(S.Header)}></Caption>
            <FilterBarForBoards />
        </Flex>
    );
};

export default BoardListFilter;
